import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from "react-toastify";
import TopHeader from "./TopHeader";
import LeftSidebar from "./LeftSidebar";
import { thirdparty } from "../..";
import { IMAGE_URL } from "../../constants";
import Pagination from "react-js-pagination";

const HomePopup = () => {
  const [formData, setFormData] = useState(null);
  const [slNo, setSlNo] = useState("");
  const [interval, setInterval] = useState(null);
  const [mediaList, setMediaList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [updateMediaId, setUpdateMediaId] = useState(null);
  const [updateFormData, setUpdateFormData] = useState(null);
  const [updateSlNo, setUpdateSlNo] = useState("");

  const itemsPerPage = 8;
  console.log("your log output", mediaList);
  // Fetch media data
  const fetchData = async () => {
    try {
      const response = await thirdparty.get("/settings?type=popup_slider");
      if (response.status === 200) {
        setMediaList(response.data); // Assuming this contains the list of media
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData(); // Fetch media on component mount
  }, []);

  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData(file);
  };

  const handleUpdateFileChange = (e) => {
    const file = e.target.files[0];
    setUpdateFormData(file);
  };

  // Handle SL No input change
  const handleSlNoChange = (e) => {
    setSlNo(e.target.value);
  };
  // Handle SL No input change
  const handleIntervalChange = (e) => {
    setInterval(e.target.value);
  };

  const handleUpdateSlNoChange = (e) => {
    setUpdateSlNo(e.target.value);
  };

  // Handle form submission for uploading media
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData || !slNo) {
      toast.error("Please select a file and enter SL No.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      return;
    }

    const postData = new FormData();
    postData.append("type", "popup_slider");
    postData.append("upload_file", formData);
    postData.append("sl_no", slNo);
    postData.append("status", 1);

    try {
      const response = await thirdparty.post("/settings", postData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status === 201) {
        toast.success("Media uploaded successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        fetchData(); // Fetch updated list after upload
      }
    } catch (error) {
      console.error("Error uploading media:", error.message);
    }
  };
  const handleUpdateIntervalTime = async (e) => {
    e.preventDefault();

    if (!interval) {
      toast.error("Please give interval time for sliders.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      return;
    }

    const postData = new FormData();
    postData.append("value", interval);

    try {
      const response = await thirdparty.post("/settings_update/26", postData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status === 200) {
        toast.success("Interval time added successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        fetchData(); // Fetch updated list after upload
      }
    } catch (error) {
      console.error("Error uploading time:", error.message);
    }
  };

  // Handle delete media
  const handleDelete = async (id) => {
    try {
      const response = await thirdparty.delete(`/settings/${id}`);
      if (response.status === 200) {
        toast.success("Media deleted successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        fetchData(); // Fetch updated list after deletion
      }
    } catch (error) {
      console.error("Error deleting media:", error.message);
    }
  };

  // Handle update media
  const handleUpdate = async (id) => {
    if (!updateFormData && !updateSlNo) {
      toast.error("Please provide updated file or SL No.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      return;
    }

    const updatedData = new FormData();
    if (updateFormData) {
      updatedData.append("upload_file", updateFormData);
    }
    if (updateSlNo) {
      updatedData.append("sl_no", updateSlNo);
    }
    updatedData.append("type", "popup_slider");
    updatedData.append("status", 1);

    try {
      const response = await thirdparty.post(
        `/settings_update/${id}`,
        updatedData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200) {
        toast.success("Media updated successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        setUpdateMediaId(null);
        fetchData(); // Fetch updated list after update
      }
    } catch (error) {
      console.error("Error updating media:", error.message);
    }
  };

  const handleUpdateClick = (media) => {
    setUpdateMediaId(media.id);
    setUpdateSlNo(media.sl_no);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = mediaList.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="container">
                <h3>Media Upload</h3>

                {/* Upload Form */}
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label htmlFor="uploadFile" className="form-label">
                        Select Media
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="uploadFile"
                        onChange={handleFileChange}
                      />
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <label htmlFor="slNo" className="form-label">
                        Serial No (SL No)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="slNo"
                        value={slNo}
                        onChange={handleSlNoChange}
                      />
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Upload
                  </button>
                </form>

                <form onSubmit={handleUpdateIntervalTime}>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label htmlFor="interval" className="form-label">
                        Interval Time For Sliders
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Put the interval time in second. e.g.,3"
                        id="interval"
                        value={interval}
                        onChange={handleIntervalChange}
                      />
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </form>

                {/* Display uploaded media */}
                <div className="mt-4">
                  <h4>Uploaded Media</h4>
                  <div className="row">
                    {currentItems.map((media) => (
                      <div className="col-4 mb-3" key={media.id}>
                        <div className="card">
                          <img
                            src={`${IMAGE_URL}${media.file_path}`}
                            alt={media.upload_file}
                            className="card-img-top"
                          />
                          <div className="card-body">
                            <h5 className="card-title">SL No: {media.sl_no}</h5>
                            {updateMediaId === media.id ? (
                              <div>
                                <input
                                  type="file"
                                  className="form-control mb-2"
                                  onChange={handleUpdateFileChange}
                                />
                                <input
                                  type="text"
                                  className="form-control mb-2"
                                  value={updateSlNo}
                                  onChange={handleUpdateSlNoChange}
                                />
                                <button
                                  className="btn btn-success"
                                  onClick={() => handleUpdate(media.id)}
                                >
                                  Save
                                </button>
                                <button
                                  className="btn btn-secondary ms-2"
                                  onClick={() => setUpdateMediaId(null)}
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              <div>
                                <button
                                  className="btn btn-outline-primary"
                                  onClick={() => handleUpdateClick(media)}
                                >
                                  Update
                                </button>
                                <button
                                  className="btn btn-outline-danger ms-2"
                                  onClick={() => handleDelete(media.id)}
                                >
                                  Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Pagination */}
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={itemsPerPage}
                    totalItemsCount={mediaList.length}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default HomePopup;



// WEBPACK FOOTER //
// ./src/component/admin/HomePopup.js